module.exports = __webpack_public_path__ + "static/media/img_41.05d71c3c.png";